import { useEffect, useRef, useState } from "react";
import { resolveUnknownFoods, type ParsedVoiceMealDraft } from "../../application/remote-meal-parser";

export function useFoodResolution(draft: ParsedVoiceMealDraft, onChange: (draft: ParsedVoiceMealDraft) => void, paused: boolean) {
  const signature = JSON.stringify(draft.nutrition?.rows.flatMap((row, i) => row.components.filter(c => c.calories === null && !c.ignored).map(c => [i, c.name])) ?? []);
  const completed = useRef(new Set<string>());
  const latest = useRef({ draft, onChange }); latest.current = { draft, onChange };
  const [error, setError] = useState("");
  const [attempt, retry] = useState(0);
  const pending = signature !== "[]" && !completed.current.has(signature) && !draft.foodLookupCompleted;
  useEffect(() => {
    if (!pending || paused) return;
    let alive = true;
    const original = latest.current.draft;
    setError("");
    void resolveUnknownFoods(original).then(updated => {
      if (!alive || latest.current.draft !== original) return;
      completed.current.add(signature);
      latest.current.onChange(updated);
    }).catch(e => { if (alive) setError(e instanceof Error ? e.message : "Не удалось проверить каталог."); });
    return () => { alive = false; };
  }, [signature, pending, paused, attempt]);
  return { pending, error, retry: () => retry(n => n + 1) };
}
